import { constUndefined, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
export var extractCookieValue = function extractCookieValue(cookie, name) {
  return pipe(new RegExp("(^| )".concat(name, "=([^;]+)")), function (regEx) {
    return O.fromNullable(cookie === null || cookie === void 0 ? void 0 : cookie.match(regEx));
  }, O.match(constUndefined, function (matches) {
    return matches[2];
  }));
};